import React, { FC, ReactElement } from "react";
import { useTranslation } from "react-i18next";
import { Control, Controller, FormState } from "react-hook-form";
import { Stack } from "@mui/material";

import { Button, TextField } from "@components/base";

export type ResetPasswordFormValues = {
  password: string;
  confirmPassword: string;
};

export interface ResetPasswordForm {
  onSubmit: (values: ResetPasswordFormValues) => void;
  control: Control<ResetPasswordFormValues>;
  formState: FormState<ResetPasswordFormValues>;
  submitting: boolean;
}

const ResetPasswordForm: FC<ResetPasswordForm> = ({
  onSubmit,
  control,
  formState,
  submitting,
}) => {
  const { t } = useTranslation();
  const { handleSubmit } = control;

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Stack direction="column" rowGap={3}>
        <Controller
          control={control}
          name="password"
          render={({
            field: { onBlur, onChange, name },
            fieldState: { error },
          }): ReactElement => (
            <TextField
              {...{ onBlur, onChange, name }}
              label={t("auth.newPassword")}
              key={"password"}
              error={Boolean(error)}
              helperText={error?.message}
              placeholder={t("auth.newPassword")}
              type="password"
              variant="outlined"
            />
          )}
        />
        <Controller
          control={control}
          name="confirmPassword"
          render={({
            field: { onBlur, onChange, name },
            fieldState: { error },
          }): ReactElement => (
            <TextField
              {...{ onBlur, onChange, name }}
              label={t("auth.confirmPassword")}
              key={"confirmPassword"}
              error={Boolean(error)}
              helperText={error?.message}
              placeholder={t("auth.confirmPassword")}
              type="password"
              variant="outlined"
            />
          )}
        />
        <Button
          isLoading={submitting}
          disabled={formState.isSubmitting || !formState.isValid}
          size="medium"
          type="submit"
          variant="contained"
        >
          {t("Reset Password")}
        </Button>
      </Stack>
    </form>
  );
};

export default ResetPasswordForm;
